import { SubscriptionWizardDialog } from './SubscriptionWizardDialog';
import { DowngradeDialog } from './DowngradeDialog';
import { UpgradeRequiredDialog } from './UpgradeRequiredDialog';
import { AddonRequiredDialog } from './AddonRequiredDialog';
import { AddonUpdateDialog } from './AddonUpdateDialog';
import { UnpaidInvoicesDialog } from './UnpaidInvoicesDialog';
import { EnableTeamBillingDialog } from './EnableTeamBillingDialog';
import { BillingInformationDialog } from './BillingInformationDialog';

/**
 * Mounts all billing dialogs at app level.
 * They open/close via billing-dialog-store (activeDialog enum).
 * Mounted in AppShell when VITE_USE_NATIVE_BILLING=true.
 */
export function BillingDialogs() {
  return (
    <>
      <SubscriptionWizardDialog />
      <DowngradeDialog />
      <UpgradeRequiredDialog />
      <AddonRequiredDialog />
      <AddonUpdateDialog />
      <UnpaidInvoicesDialog />
      <EnableTeamBillingDialog />
      <BillingInformationDialog />
    </>
  );
}
